import './Booking.css'
import React, { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import Select from 'react-select';
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css"
import DateRangeIcon from '@mui/icons-material/DateRange';
import { Link } from 'react-router-dom';
import axios from 'axios';
import api from '../../webconfig'
import Swal from 'sweetalert2';
import sucessPayment from '../../asset/img/sucessPayment.jpg'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { ToastContainer, toast } from 'react-toastify';
const Booking = () => {
    // State to track the active tab
    const roomTypeArray = [
        { id: 1, value: 'Villa' },
        { id: 2, value: 'Mezzanine Rooms' },
        { id: 3, value: 'Rooms' }
    ]
    const childAgeArray = [
        { id: 1, value: 1 },
        { id: 2, value: 2 },
        { id: 3, value: 3 },
        { id: 4, value: 4 },
        { id: 5, value: 5 },
        { id: 6, value: 6 },
        { id: 7, value: 7 },
        { id: 8, value: 8 },
        { id: 9, value: 9 },
        { id: 10, value: 10 },
        { id: 11, value: 11 },
        { id: 12, value: 12 },
    ]
    const {
        register: registerBooking,
        handleSubmit: handleSubmitBooking,
        setValue: setValueBooking,
        reset: resetBooking,
        control: controlBooking,
        getValues: getValuesBooking,
        formState: { errors: errorsBooking }
    } = useForm({
        defaultValues: {
            name: '',
            email: '',
            phone: '',
            roomTypeID: null,
            fromDate: null,
            toDate: null,
            adult: 1,
            children: null,
            noOfRooms: null
        }
    });

    const [activeTab, setActiveTab] = useState('details');
    const [roomCountArray, setRoomCountArray] = useState([])

    // bind in the summary
    const [customerName, setCustomerName] = useState('');
    const [customerCheckIn, setCustomerCheckIn] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerCheckOut, setCustomerCheckOut] = useState('');
    const [customerMobile, setCustomerMobile] = useState('');
    const [bookingDetailsArray, setBookingDetailsArray] = useState([]);
    const [selectRoomType, setSelectRoomType] = useState(0);
    const [adultCountArray, setAdultCountArray] = useState([]);
    const [childCountArray, setChildCountArray] = useState([]);
    const [roomDetailsArray, setRoomDetailsArray] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalDays, setTotalDays] = useState(0);

    useEffect(() => {
        const fetchRooms = async () => {
            try {
                const response = await axios.get(api + '/roomlist');

                setRoomDetailsArray(response.data);
            } catch (error) {
                console.error('Error fetching request category:', error)
                // throw error;
            }
        };
        fetchRooms();
    }, []);

    // Handle tab click
    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };
    const selectRoomOnchange = (selectedOption, bookedRooms, checkAvailablitiyRooms) => {
        debugger
        setAdultCountArray([]);
        setChildCountArray([]);
        if (bookedRooms == 0 && checkAvailablitiyRooms == false && selectedOption.id == 1) {
            setRoomCountArray([])
            setAdultCountArray([]);
            setChildCountArray([]);
            setSelectRoomType(selectRoomType);
            toast.warning("No Rooms Available for this Dates.")
        } else {
            if (selectedOption != null) {
                if (selectedOption.id == 1) {
                    const villaCount = [
                        {
                            id: 1,
                            value: 1
                        }
                    ]
                    setRoomCountArray(villaCount);
                    setSelectRoomType(1);
                    if (checkAvailablitiyRooms) {
                        checkAvailability(customerCheckIn, customerCheckOut, 1)
                    }
                } else if (selectedOption.id == 2) {
                    const availableRooms = 3 - bookedRooms;
                    let mezzanineCount = []
                    if (availableRooms == 1) {
                        mezzanineCount = [
                            {
                                id: 1,
                                value: 1
                            }
                        ]
                    } else if (availableRooms == 2) {
                        mezzanineCount = [
                            {
                                id: 1,
                                value: 1
                            },
                            {
                                id: 2,
                                value: 2
                            }
                        ]
                    } else if (availableRooms == 3) {
                        mezzanineCount = [
                            {
                                id: 1,
                                value: 1
                            },
                            {
                                id: 2,
                                value: 2
                            },
                            {
                                id: 3,
                                value: 3
                            }
                        ]
                    }
                    if (mezzanineCount.length == 0) {
                        toast.warning("No Rooms Available for this Dates.")
                    }
                    setRoomCountArray(mezzanineCount);
                    setSelectRoomType(2);
                    if (checkAvailablitiyRooms) {
                        checkAvailability(customerCheckIn, customerCheckOut, 2)
                    }

                } else if (selectedOption.id == 3) {
                    const availableRooms = 2 - bookedRooms;
                    let roomCount = [];
                    if (availableRooms == 1) {
                        roomCount = [
                            {
                                id: 1,
                                value: 1
                            }
                        ]
                    } else if (availableRooms == 2) {
                        roomCount = [
                            {
                                id: 1,
                                value: 1
                            },
                            {
                                id: 2,
                                value: 2
                            }
                        ]
                    }
                    if (roomCount.length == 0) {
                        toast.warning("No Rooms Available for this Dates.")
                    }
                    setRoomCountArray(roomCount);
                    setSelectRoomType(3);
                    if (checkAvailablitiyRooms) {
                        checkAvailability(customerCheckIn, customerCheckOut, 3)
                    }

                }
            } else {
                setRoomCountArray([])
                setAdultCountArray([]);
                setChildCountArray([]);
                setSelectRoomType(0);
                if (checkAvailablitiyRooms) {
                    checkAvailability(customerCheckIn, customerCheckOut, 0)
                }
            }
        }



    };
    const onSubmit = (data) => {

        const start = new Date(data.fromDate);
        const end = new Date(data.toDate);
        let noOfDays = 0
        if (start && end && start <= end) {
            const timeDifference = end - start;
            const days = timeDifference / (1000 * 3600 * 24);
            noOfDays = Math.floor(days);
            setTotalDays(noOfDays)
        } else {
            alert('Invalid dates or start date is after end date');
        }
        let roomArray = [];
        const roomCost = roomDetailsArray.find(x => x.ID == data.roomTypeID).COST;
        const roomDetails = {
            stayType: roomTypeArray.find(x => x.id == data.roomTypeID).value,
            totalNoOfRooms: data.noOfRooms,
            noOfAdult: data.adult,
            noOfChild: data.children == null ? 0 : data.children,
            totalNoOfDays: noOfDays,
            amtPerRoom: roomCost,
            amtPerDay: data.noOfRooms * roomCost,
            totalAmt: data.noOfRooms * noOfDays * roomCost
        }
        roomArray.push(roomDetails);
        setBookingDetailsArray(roomArray);
        setCustomerName(data.name);
        setCustomerEmail(data.email);
        setCustomerMobile(data.phone);
        setCustomerCheckIn(formatDate(start))
        setCustomerCheckOut(formatDate(end))
        setTotalAmount(data.noOfRooms * noOfDays * roomCost);
        handleTabClick('summary')
    };
    const currentformatDate = () => {
        const date = new Date();
        const options = {
            weekday: 'short', // Optional: can add to display the day of the week
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: true, // this ensures AM/PM format
        };

        return new Intl.DateTimeFormat('en-US', options).format(date);
    };
    const proceedPayment = async () => {
        Swal.fire({
            title: 'Are you sure want to Make the Payment?',
            text: '',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Make the Payment',
            cancelButtonText: 'No, cancel!',
        }).then((result) => {
            if (result.isConfirmed) {
                const amount = totalAmount;
                const options = {
                    key: "rzp_test_iE5jUAnLZJZOBs", // Replace with your API key
                    key_secret: "fVde0bfFUi88eCozXH7m49uR",
                    amount: amount * 100, // Amount in paise (₹500)
                    currency: "INR",
                    name: "Lé Heaven Inn",
                    description: "Room/Villa Booking",
                    // image: "https://your-logo-url.com/logo.png",
                    handler: async function (response) {
                        const fromDateValue = new Date(getValuesBooking('fromDate'))
                        const toDateValue = new Date(getValuesBooking('toDate'))
                        const currentDate = currentformatDate();

                        if (response.razorpay_payment_id != null && response.razorpay_payment_id != '' && response.razorpay_payment_id != undefined && response.razorpay_payment_id != 0) {
                            // const tyep = roomTypeArray.find(x => x.value == bookingDetailsArray[0].stayType).id

                            const orderPayLoad = {
                                CUS_NAME: customerName,
                                CUS_EMAIL: customerEmail,
                                CUS_MOB: customerMobile,
                                CUS_ROOMTYPE: roomTypeArray.find(x => x.value == bookingDetailsArray[0].stayType).id,
                                CUS_FROMDATE: formatDate(fromDateValue),
                                CUS_TODATE: formatDate(toDateValue),
                                CUS_NOOFROOMS: bookingDetailsArray[0].totalNoOfRooms,
                                CUS_NOOFADULT: bookingDetailsArray[0].noOfAdult,
                                CUS_NOOFCHILDREN: bookingDetailsArray[0].noOfChild,
                                CUS_AMTPERROOM: bookingDetailsArray[0].amtPerRoom,
                                CUS_AMTPERDAY: bookingDetailsArray[0].amtPerDay,
                                CUS_TOTALAMT: bookingDetailsArray[0].totalAmt,
                                CREATED_DATE: currentDate,
                                CUS_PAYMENTID: response.razorpay_payment_id,
                                CUS_NOOFDAYS: bookingDetailsArray[0].noOfDays
                            }
                            try {
                                // Make POST request to the /orders API endpoint
                                const response = await axios.post(`${api}/orders`, orderPayLoad, {
                                    headers: {
                                        'Content-Type': 'application/json'
                                    }
                                });
                                if (response.data.message == 'Order placed successfully') {
                                    setActiveTab('payment');
                                }

                            } catch (error) {
                                console.error('Error creating order:', error);
                            }

                        }
                        console.log(response);
                    },
                    prefill: {
                        name: customerName,
                        email: customerEmail,
                        contact: customerMobile
                    },
                    theme: {
                        color: "#3399cc",
                        // hide_topbar: true,
                    },
                };

                const rzp = new window.Razorpay(options);
                rzp.open();
                // Swal.fire('Deleted!', 'Your file has been deleted.', 'success');
                // Perform delete operation here
            }
            else {
                Swal.fire('Cancelled', 'Payment not Proceed', 'info');
            }
        });


    }
    function formatDate(date) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }
    const roomSelectOnChange = (selectedOption) => {
        if (selectedOption != null) {
            if (selectedOption.value == 1 && selectRoomType == 1) {
                const adultCount = [
                    { id: 1, value: 1 },
                    { id: 2, value: 2 },
                    { id: 3, value: 3 },
                    { id: 4, value: 4 },
                    { id: 5, value: 5 },
                    { id: 6, value: 6 },
                    { id: 7, value: 7 },
                ]
                setAdultCountArray(adultCount);
                setChildCountArray(adultCount);

            } else if (selectedOption.value == 1 && selectRoomType != 1) {
                const adultCount = [
                    { id: 1, value: 1 },
                    { id: 2, value: 2 }
                ]
                setAdultCountArray(adultCount);
                setChildCountArray(adultCount);
            } else if (selectedOption.value == 2 && selectRoomType != 1) {
                const adultCount = [
                    { id: 1, value: 1 },
                    { id: 2, value: 2 },
                    { id: 3, value: 3 },
                    { id: 4, value: 4 }
                ]
                setAdultCountArray(adultCount);
                setChildCountArray(adultCount);
            } else if (selectedOption.value == 3 && selectRoomType != 1) {
                const adultCount = [
                    { id: 1, value: 1 },
                    { id: 2, value: 2 },
                    { id: 3, value: 3 },
                    { id: 4, value: 4 },
                    { id: 5, value: 5 },
                    { id: 6, value: 6 }
                ]
                setAdultCountArray(adultCount);
                setChildCountArray(adultCount);
            }
        } else {
            setAdultCountArray([]);
            setChildCountArray([]);
        }


    }
    const proceedPaymentBack = () => {
        handleTabClick('details')
    }

    const dateOnChange = (date, value) => {
        if (value == 'fromDate') {
            if (date != null && date != undefined && date != '') {
                const start = new Date(date);
                const fromatedDate = formatDate(start);
                setCustomerCheckIn(fromatedDate)
                checkAvailability(fromatedDate, customerCheckOut, selectRoomType)
            } else {
                setCustomerCheckIn('')
                checkAvailability('', customerCheckOut, selectRoomType)
            }

        } else if (value == 'toDate') {
            if (date != null && date != undefined && date != '') {
                const end = new Date(date);
                const fromatedDate = formatDate(end)
                setCustomerCheckOut(fromatedDate)
                checkAvailability(customerCheckIn, fromatedDate, selectRoomType)
            } else {
                setCustomerCheckOut('')
                checkAvailability(customerCheckIn, '', selectRoomType)

            }
        }

    }
    const checkAvailability = async (customerCheckIn, customerCheckOut, selectRoomType) => {
        debugger
        if (customerCheckIn != undefined && customerCheckIn != null && customerCheckIn != '' && customerCheckOut != undefined && customerCheckOut != null && customerCheckOut != '' && selectRoomType != undefined && selectRoomType != null && selectRoomType != 0) {

            const [dayCheckIn, monthCheckIn, yearCheckIn] = customerCheckIn.split('/');
            const formattedDateCheckIn = `${yearCheckIn}-${monthCheckIn.padStart(2, '0')}-${dayCheckIn.padStart(2, '0')}`;

            const [dayCheckOut, monthCheckOut, yearCheckOut] = customerCheckOut.split('/');
            const formattedDateCheckOut = `${yearCheckOut}-${monthCheckOut.padStart(2, '0')}-${dayCheckOut.padStart(2, '0')}`;

            const checkAvailablityPayLoad = {
                CUS_ROOMTYPE: selectRoomType,
                CUS_FROMDATE: formattedDateCheckIn,
                CUS_TODATE: formattedDateCheckOut
            }
            try {
                // Make POST request to the /orders API endpoint
                const response = await axios.post(`${api}/check-availability`, checkAvailablityPayLoad, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                debugger
                if (response.data.bookingArray.length > 0) {
                    if (response.data.bookingArray[0].CUS_ROOMTYPE == 1) {
                        selectRoomOnchange({ id: 1, value: 'Villa' }, 0, false)
                    } else if (selectRoomType == 1 && response.data.bookingArray.length > 0) {
                        selectRoomOnchange({ id: 1, value: 'Villa' }, 0, false)
                    }
                    else {
                        let totalRoomsCount = 0;
                        response.data.bookingArray.forEach((bookedRooms) => {
                            totalRoomsCount += bookedRooms.CUS_NOOFROOMS
                        })
                        if (selectRoomType == 2) {
                            selectRoomOnchange({ id: 2, value: 'Mezzanine Rooms' }, totalRoomsCount, false)
                        } else if (selectRoomType == 3) {
                            selectRoomOnchange({ id: 3, value: 'Rooms' }, totalRoomsCount, false)
                        }
                    }
                }

            } catch (error) {
                debugger
                console.error('Error creating order:', error);
            }

        }
    }
    return (

        <div className='~p-5'>
            <ToastContainer theme="colored" />
            <div className='heading'>
                Welcome To Lé Heaven Inn
            </div>
            <div className='Subheading'>
                Book Your Rooms or Villa
            </div>
            <div className='stepper'>
                <div>
                    <ul className="nav nav-tabs" id="myTab" role="tablist" style={{ justifyContent: 'space-between' }}>
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link btnwidth ${activeTab === 'details' ? 'active activeBtn' : ''}`}
                                id="home-tab"
                                data-bs-toggle="tab"
                                type="button"
                                role="tab"
                                aria-controls="home"
                                aria-selected={activeTab === 'details'}
                                style={{ cursor: 'default' }}
                                // onClick={() => handleTabClick('details')}
                                // style={{ width: '200px' }}
                                disabled
                            >
                                Details
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link btnwidth ${activeTab === 'summary' ? 'active activeBtn' : ''}`}
                                id="profile-tab"
                                data-bs-toggle="tab"
                                type="button"
                                role="tab"
                                aria-controls="profile"
                                aria-selected={activeTab === 'summary'}
                                style={{ cursor: 'default' }}
                                // onClick={() => handleTabClick('summary')}
                                // style={{ width: '200px' }}
                                disabled
                            >
                                Summary
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button
                                className={`nav-link btnwidth ${activeTab === 'payment' ? 'active activeBtn' : ''}`}
                                id="contact-tab"
                                data-bs-toggle="tab"
                                type="button"
                                role="tab"
                                aria-controls="contact"
                                aria-selected={activeTab === 'payment'}
                                style={{ cursor: 'default' }}
                                // onClick={() => handleTabClick('payment')}
                                // style={{ width: '200px' }}
                                disabled
                            >
                                Payment
                            </button>
                        </li>
                    </ul>
                </div>

                {/* Tab Content */}
                <div className="tab-content" id="myTabContent">
                    <div
                        className={`tab-pane fade ${activeTab === 'details' ? 'show active' : ''}`}
                        id="home"
                        role="tabpanel"
                        aria-labelledby="home-tab"
                    >
                        <form onSubmit={handleSubmitBooking(onSubmit)}>
                            <div className='row mt-1'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    {/* Name input with validation */}
                                    <div>
                                        <label>Name <span className='mantatoryField'>*</span> </label>
                                        <input
                                            className='textinputCustom'
                                            placeholder='Enter the Name'
                                            {...registerBooking('name', { required: 'Please Enter the Name' })}
                                        />
                                        {errorsBooking.name && (
                                            <div className='invalid-feedback' style={{ display: 'block', fontSize: '16px', fontWeight: '400' }}>
                                                {errorsBooking.name.message}
                                            </div>

                                        )}
                                    </div>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    {/* Email input with validation */}
                                    <div>
                                        <label>Email<span className='mantatoryField'>*</span></label>
                                        <input
                                            className='textinputCustom'
                                            type="email"
                                            placeholder='Enter email'
                                            {...registerBooking('email', {
                                                required: 'Please Enter the Email ID',
                                                pattern: {
                                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                    message: 'Invalid email address'
                                                }
                                            })}
                                        />
                                        {errorsBooking.email && (
                                            <div className='invalid-feedback' style={{ display: 'block', fontSize: '16px', fontWeight: '400' }}>
                                                {errorsBooking.email.message}
                                            </div>

                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='row mt-1'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    {/* Name input with validation */}
                                    <div>
                                        <label>Phone Number<span className='mantatoryField'>*</span></label>
                                        <input
                                            type="text"
                                            maxLength="10"
                                            className='textinputCustom'
                                            placeholder='Enter the Name'
                                            {...registerBooking('phone', { required: 'Please Enter the Phone Number' })}
                                        />
                                        {errorsBooking.name && (
                                            <div className='invalid-feedback' style={{ display: 'block', fontSize: '16px', fontWeight: '400' }}>
                                                {errorsBooking.phone.message}
                                            </div>

                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-6 col-sm-12">
                                    <div>
                                        Select Room Type<span className='mantatoryField'>*</span>
                                    </div>
                                    <div>
                                        <Controller
                                            name="roomTypeID"
                                            control={controlBooking}
                                            rules={{ required: 'Please select a Room Type' }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    value={roomTypeArray.find(c => c.id === field.value) || null}
                                                    onChange={(selectedOption) => {
                                                        field.onChange(selectedOption ? selectedOption.id : null);
                                                        selectRoomOnchange(selectedOption, 0, true);
                                                    }}
                                                    options={roomTypeArray}
                                                    getOptionLabel={(option) => option.value}
                                                    getOptionValue={(option) => option.id}
                                                    placeholder="Select Room Type"
                                                    isClearable
                                                    isSearchable
                                                    className={`${errorsBooking.roomTypeID ? 'is-invalid' : ''}`}
                                                />
                                            )}
                                        />
                                    </div>
                                    {errorsBooking.roomTypeID && (
                                        <div className="invalid-feedback" style={{ display: 'block', fontSize: '16px', fontWeight: '400' }}>
                                            {errorsBooking.roomTypeID.message}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className='row mt-1'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <div>
                                        <div>
                                            From Date<span className='mantatoryField'>*</span>
                                        </div>
                                        <div className='position-relative'>
                                            <Controller
                                                name="fromDate"
                                                control={controlBooking}
                                                rules={{
                                                    validate: {
                                                        validDate: (value) => {
                                                            if (!value) {
                                                                return "Please Enter the From Date";
                                                            }
                                                            return true;
                                                        }
                                                    }
                                                }}
                                                render={({ field }) => (
                                                    <DatePicker
                                                        {...field}
                                                        selected={field.value}
                                                        onChange={(date) => {
                                                            field.onChange(date);
                                                            dateOnChange(date, 'fromDate');
                                                        }}
                                                        dateFormat='dd/MM/yyyy'
                                                        className="date-picker-input customDatePicker"
                                                        ref={(input) => field.ref(input?.inputElement)}
                                                        minDate={new Date()}
                                                    />
                                                )}
                                            />
                                            {/* <DateRangeIcon className='dateFromIcon' /> */}
                                        </div>
                                        {errorsBooking.fromDate && (
                                            <div className="invalid-feedback" style={{ display: "block", fontSize: '16px', fontWeight: '400' }}>
                                                {errorsBooking.fromDate.message}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <div>
                                        <div>
                                            To Date<span className='mantatoryField'>*</span>
                                        </div>
                                        <div>
                                            <Controller
                                                name="toDate"
                                                control={controlBooking}
                                                rules={{
                                                    validate: {
                                                        validDate: (value) => {
                                                            if (!value) {
                                                                return "Please Enter the To Date";
                                                            }
                                                            return true;
                                                        }
                                                    }
                                                }}
                                                render={({ field }) => (
                                                    <DatePicker
                                                        {...field}
                                                        selected={field.value}
                                                        onChange={(date) => {
                                                            field.onChange(date);
                                                            dateOnChange(date, 'toDate');
                                                        }}
                                                        dateFormat='dd/MM/yyyy'
                                                        className="date-picker-input customDatePicker"
                                                        ref={(input) => field.ref(input?.inputElement)}
                                                        minDate={new Date()}
                                                    />
                                                )}
                                            />
                                            {/* <DateRangeIcon className='dateToIcon' /> */}
                                        </div>

                                        {errorsBooking.toDate && (
                                            <div className="invalid-feedback" style={{ display: "block", fontSize: '16px', fontWeight: '400' }}>
                                                {errorsBooking.toDate.message}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='row mt-1'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <div>
                                        Select Rooms<span className='mantatoryField'>*</span>
                                    </div>
                                    <div>
                                        <Controller
                                            name="noOfRooms"
                                            control={controlBooking}
                                            rules={{ required: 'Please select a Room' }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    value={roomCountArray.find(c => c.id === field.value) || null}
                                                    onChange={(selectedOption) => {
                                                        field.onChange(selectedOption ? selectedOption.id : null);
                                                        roomSelectOnChange(selectedOption);
                                                        // setCategorySelectID(selectedOption ? selectedOption.id : null); // Update state
                                                    }}
                                                    options={roomCountArray}
                                                    getOptionLabel={(option) => option.value}
                                                    getOptionValue={(option) => option.id}
                                                    placeholder="Select Rooms"
                                                    isClearable
                                                    isSearchable
                                                    className={`${errorsBooking.noOfRooms ? 'is-invalid' : ''}`}
                                                />
                                            )}
                                        />
                                        {errorsBooking.noOfRooms && (
                                            <div className="invalid-feedback" style={{ display: 'block', fontSize: '16px', fontWeight: '400' }}>
                                                {errorsBooking.noOfRooms.message}
                                            </div>
                                        )}
                                    </div>

                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 mt-1 d-flex' style={{ padding: '0px' }}>
                                    <div className='col-lg-6 col-md-6 col-sm-12'>
                                        <div>
                                            Select Adult<span className='mantatoryField'>*</span>
                                        </div>
                                        <div>
                                            <Controller
                                                name="adult"
                                                control={controlBooking}
                                                rules={{ required: 'Please select a adult' }}
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        value={adultCountArray.find(c => c.id === field.value) || null}
                                                        onChange={(selectedOption) => {
                                                            field.onChange(selectedOption ? selectedOption.id : null);
                                                            // setCategorySelectID(selectedOption ? selectedOption.id : null); // Update state
                                                        }}
                                                        options={adultCountArray}
                                                        getOptionLabel={(option) => option.value}
                                                        getOptionValue={(option) => option.id}
                                                        placeholder="Select Room Type"
                                                        // isClearable
                                                        // isSearchable
                                                        className={`${errorsBooking.adult ? 'is-invalid' : ''}`}
                                                    />
                                                )}
                                            />
                                        </div>
                                        {errorsBooking.adult && (
                                            <div className="invalid-feedback" style={{ display: 'block', fontSize: '16px', fontWeight: '400' }}>
                                                {errorsBooking.adult.message}
                                            </div>
                                        )}
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-sm-12'>
                                        <div>
                                            Select Child
                                        </div>
                                        <div>
                                            <Controller
                                                name="children"
                                                control={controlBooking}
                                                // rules={{ required: 'Please select a adult' }}
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        value={childCountArray.find(c => c.id === field.value) || null}
                                                        onChange={(selectedOption) => {
                                                            field.onChange(selectedOption ? selectedOption.id : null);
                                                            // setCategorySelectID(selectedOption ? selectedOption.id : null); // Update state
                                                        }}
                                                        options={childCountArray}
                                                        getOptionLabel={(option) => option.value}
                                                        getOptionValue={(option) => option.id}
                                                        placeholder="Select Children"
                                                        isClearable
                                                    // isSearchable
                                                    // className={`${errorsBooking.adult ? 'is-invalid' : ''}`}
                                                    />
                                                )}
                                            />
                                        </div>

                                    </div>
                                </div>

                            </div>
                            {/* Submit button */}
                            <div className='d-flex justify-content-center align-items-center mt-2'>
                                <Link to="/" style={{ color: 'white' }}><button className='mt-3 btn btn-danger'>Cancel</button></Link>
                                <button type="submit" className='mt-3 btn btn-success ml-3'>Proceed</button>
                            </div>

                        </form>
                    </div>
                    <div
                        className={`tab-pane fade ${activeTab === 'summary' ? 'show active' : ''}`}
                        id="profile"
                        role="tabpanel"
                        aria-labelledby="profile-tab"
                    >
                        <div className='mt-4'>
                            <div className='text-center Summaryheading'>Lé Heaven Inn</div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <div>
                                        <span className='contentHeading'>Name: </span><span className='contentValue'>{customerName}</span>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 textalignment ~text-right'>
                                    <span className='contentHeading'>Check-In: </span><span className='contentValue'>{customerCheckIn}</span>
                                </div>
                            </div>
                            <div className='row mt-2'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <div>
                                        <span className='contentHeading'>Email: </span><span className='contentValue'>{customerEmail}</span>
                                    </div>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 ~text-right textalignment'>
                                    <span className='contentHeading'>Check-Out: </span><span className='contentValue'>{customerCheckOut}</span>
                                </div>
                            </div>
                            <div className='row mt-2'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <div>
                                        <span className='contentHeading'>Mobile No: </span><span className='contentValue'>{customerMobile}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='mt-3'>
                                <div className="table-responsive-sm">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th scope="col" className='text-center'>SI.No</th>
                                                <th scope="col" className='text-center'>Stay Type</th>
                                                <th scope="col" className='text-center'>No.of Rooms</th>
                                                <th scope="col" className='text-center'>No.of Adult</th>
                                                <th scope="col" className='text-center'>No.of Child</th>
                                                <th scope="col" className='text-center'>No.of Days</th>
                                                <th scope="col" className='text-center'>Amount per Room</th>
                                                <th scope="col" className='text-center'>Amount per Day</th>
                                                <th scope="col" className='text-center'>Total Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {bookingDetailsArray.map((booking, index) => (
                                                <tr key={index + 1}>
                                                    <td className='d-block d-sm-table-cell text-center' data-label="SI.No">{index + 1}</td>
                                                    <td className='d-block d-sm-table-cell text-center' data-label="Stay Type">{booking.stayType}</td>
                                                    <td className='d-block d-sm-table-cell text-center' data-label="No.of Rooms">{booking.totalNoOfRooms}</td>
                                                    <td className='d-block d-sm-table-cell text-center' data-label="No.of Adult">{booking.noOfAdult}</td>
                                                    <td className='d-block d-sm-table-cell text-center' data-label="No.of Child">{booking.noOfChild}</td>
                                                    <td className='d-block d-sm-table-cell text-center' data-label="No.of Days">{booking.totalNoOfDays}</td>
                                                    <td className='d-block d-sm-table-cell text-center' data-label="Amount per Room">{booking.amtPerRoom}</td>
                                                    <td className='d-block d-sm-table-cell text-center' data-label="Amount per Day">{booking.amtPerDay}</td>
                                                    <td className='d-block d-sm-table-cell text-center' data-label="Total Amount">{booking.totalAmt}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className='mt-2 text-center mt-2'>
                                <button className='mt-3 btn btn-danger ml-3' onClick={() => proceedPaymentBack()}>Back</button>
                                <button className='mt-3 btn btn-success ml-3' onClick={() => proceedPayment()}>Proceed</button>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`tab-pane fade ${activeTab === 'payment' ? 'show active' : ''}`}
                        id="contact"
                        role="tabpanel"
                        aria-labelledby="contact-tab"
                    >
                        <div className='text-center'>
                            <img src={sucessPayment} alt="" className='paymentImgWidth' />
                        </div>
                        <div>
                            <div className='paymentsucessText'>
                                Payment Done Sucessfully!
                            </div>
                            <div className='bookedText'>
                                Room/Villa has been booked for {totalDays} days sucessfully!
                            </div>
                            <div className='text-center'>
                                <Link to="/"><button className='mt-3 btn btn-danger ml-3'>Back To Site</button></Link>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    )
}

export default Booking;